import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
// import DashboardUI from '@/pages/coreui/Dashboard'
import Charts from '@/pages/coreui/Charts'
import Widgets from '@/pages/coreui/Widgets'

// Views - Components
import Buttons from '@/pages/coreui/Buttons'
import SocialButtons from '@/pages/coreui/SocialButtons'
import Cards from '@/pages/coreui/Cards'
import Forms from '@/pages/coreui/Forms'
import Modals from '@/pages/coreui/Modals'
import Switches from '@/pages/coreui/Switches'
import Tables from '@/pages/coreui/Tables'

// Views - Icons
import FontAwesome from '@/pages/coreui/icons/FontAwesome'
import SimpleLineIcons from '@/pages/coreui/icons/SimpleLineIcons'
// Views - Pages
import Page404 from '@/pages/other/Page404'
import Page500 from '@/pages/other/Page500'
// import Login from '@/pages/other/Login'
import Register from '@/pages/other/Register'

// Dashboard
import Dashboard from '@/pages/dashboard/Dashboard'

import DoctorEditStep1 from '@/pages/doctor/steps/General'
import DoctorEditStep2 from '@/pages/doctor/steps/Experience'
import DoctorEditStep3 from '@/pages/doctor/steps/Schedules'
import DoctorEditStep4 from '@/pages/doctor/steps/Education'
import DoctorEditStep5 from '@/pages/doctor/steps/Info'

import DoctorSetting from '@/pages/doctor/Setting'

// Clinic's Steps
import MainClinic from '@/pages/clinic/steps/Clinic'
import ClinicSingleForm from '@/pages/clinic/steps/SingleForm'
import ClinicSetting from '@/pages/clinic/Setting'

import LeaveList from '@/pages/clinic/leave/LeaveList'
import LeaveDetail from '@/pages/clinic/leave/LeaveDetail'

// Patient
import Patient from '@/pages/patient/Patient'

// Aritcle
import Article from '@/pages/article/Article'

// Appointment
import Appointment from '@/pages/appointment/Appointment'
import AppointmentCalendar from '@/pages/appointment/AppointmentCalendar'
import AppointmentDetail from '@/pages/appointment/AppointmentDetail'

// Feedback
import Feedback from '@/pages/feedback/Feedback'

// Report
import Report from '@/pages/report/Report'

import Login from '@/pages/auth/Login'

import Package from '@/pages/package/Package'

import ClinicMulti from '@/pages/dashboard/ClinicMulti'

import PackagePaymentStep1 from '@/pages/package/payment/step1'
import PackagePaymentStep2 from '@/pages/package/payment/step2'
import PackagePaymentStep3 from '@/pages/package/payment/step3'

import DirectPayment from '@/pages/package/payment/direct'

import MySubscription from '@/pages/package/MySubscription'

import Broadcast from '@/pages/broadcast/Broadcast'

Vue.use(Router)

var router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'clinic_multi',
          name: 'Clinic Multi',
          component: ClinicMulti,
          props: true
        },
        {
          path: 'doctor',
          redirect: '/doctor/step1/me',
          name: 'Doctor',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'step1/:id',
              name: 'Step 1',
              component: DoctorEditStep1,
              props: true
            },
            {
              path: 'step2/:id',
              name: 'Step 2',
              component: DoctorEditStep2,
              props: true
            },
            {
              path: 'step3/:id',
              name: 'Step 3',
              component: DoctorEditStep3,
              props: true
            },
            {
              path: 'step4/:id',
              name: 'Step 4',
              props: true,
              component: DoctorEditStep4
            },
            {
              path: 'step5/:id',
              name: 'Step 5',
              props: true,
              component: DoctorEditStep5
            }
          ]
        },
        {
          path: 'doctor/leave',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'DoctorLeaveList',
              component: LeaveList
            },
            {
              path: 'add',
              props: true,
              name: 'DoctorLeaveAdd',
              component: LeaveDetail
            },
            {
              path: ':id',
              props: true,
              name: 'DoctorLeaveDetail',
              component: LeaveDetail
            }
          ]
        },
        {
          path: 'doctor/setting',
          props: true,
          name: 'DoctorSetting',
          component: DoctorSetting
        },
        {
          path: 'clinic/setting',
          props: true,
          name: 'ClinicSetting',
          component: ClinicSetting
        },
        {
          path: 'clinic/leave',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'LeaveList',
              component: LeaveList
            },
            {
              path: 'add',
              props: true,
              name: 'LeaveAdd',
              component: LeaveDetail
            },
            {
              path: ':doctor_id/:id',
              props: true,
              name: 'LeaveDetail',
              component: LeaveDetail
            }
          ]
        },
        {
          path: 'clinic/steps/:step',
          props: true,
          name: 'Clinic',
          component: MainClinic
        },
        {
          path: 'clinic/:page',
          props: true,
          name: 'ClinicSingleForm',
          component: ClinicSingleForm
        },
        {
          path: 'patient',
          name: 'Patient',
          component: Patient
        },
        {
          path: 'patient/:id',
          props: true,
          name: 'PatientId',
          component: Patient
        },
        {
          path: 'article',
          name: 'article',
          component: Article
        },
        {
          path: 'article/:id',
          props: true,
          name: 'ArticleDetail',
          component: Article
        },
        {
          path: 'appointments',
          name: 'appointments',
          component: AppointmentCalendar,
          beforeEnter (to, from, next) {
            /* let ismobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
            // desktop and signed in with doctor role
            if (ismobile || (!ismobile && UserStore.store.isDoctor())) {
              // mobile
              let newPath = Object.assign({}, { path: '/appointment_m', query: to.query })
              next(newPath)
            } else {
              // desktop
              next()
            } */
            next()
          }
        },
        {
          path: 'appointment',
          name: 'appointments_calendar',
          component: AppointmentCalendar,
          beforeEnter (to, from, next) {
            /* let ismobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
            // desktop and signed in with doctor role
            if (ismobile || (!ismobile && UserStore.store.isDoctor())) {
              // mobile
              let newPath = Object.assign({}, { path: '/appointment_m', query: to.query })
              next(newPath)
            } else {
              // desktop
              next()
            } */
            next()
          }
        },
        { // to distinguish with appointment path so the menus can recognize (hilight)
          path: 'appointment_m',
          name: 'appointment_mobile',
          component: Appointment
        },
        {
          path: 'appointments/:id',
          name: 'appointment_detail',
          component: AppointmentDetail
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'report',
          name: 'Report',
          component: Report
        },
        {
          path: 'package',
          name: 'Package',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'Package',
              component: Package
            },
            {
              path: 'me',
              name: 'MySubscription',
              component: MySubscription
            },
            {
              path: 'payment/direct',
              name: 'DirectPayment',
              component: DirectPayment
            },
            {
              path: 'payment/step1',
              name: 'PaymentStep1',
              component: PackagePaymentStep1
            },
            {
              path: 'payment/step2',
              name: 'PaymentStep2',
              component: PackagePaymentStep2
            },
            {
              path: 'payment/step3',
              name: 'PaymentStep3',
              component: PackagePaymentStep3
            }
          ]
        },
        {
          path: 'feedback',
          props: true,
          name: 'Feedback',
          component: Feedback
        },
        {
          path: 'broadcast',
          props: true,
          name: 'Broadcast',
          component: Broadcast
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'components',
          redirect: '/components/buttons',
          name: 'Components',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'buttons',
              name: 'Buttons',
              component: Buttons
            },
            {
              path: 'social-buttons',
              name: 'Social Buttons',
              component: SocialButtons
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
    {
      path: '/auth/login',
      name: 'Login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Switch lang
  if (to.query.lang) {
    UserStore.changeLang(to.query.lang)
  }

  // Fetch user data
  let fetchedUser = false
  let user = UserStore.getUser()

  // Fetch user data, if it is the first time user has signed in
  if (!UserStore.signedIn()) {
    fetchedUser = true
  // If user switch from multiClinic view to Clinic view
  } if (to.query.ref_clinic_id && UserStore.store.isClinicMulti() && !UserStore.store.user.clinic) {
    fetchedUser = true
  // Fetch user data if the user has different clinic_id
  } else if (to.query.ref_clinic_id && user && user.clinic && user.clinic.id &&
  parseInt(user.clinic.id) !== parseInt(to.query.ref_clinic_id)) {
    fetchedUser = true
  }

  if (fetchedUser) {
    Vue.http.get(process.env.API_URL + '/api/v1/users/me', { params: {
      clinic_id: to.query.ref_clinic_id
    }}).then(res => {
      // Success
      UserStore.setUser(res.data)
      if (to.path === '/' && UserStore.store.isClinicMulti()) {
        next({path: '/clinic_multi'})
      } else if (to.path === '/' && UserStore.store.isDoctor()) {
        next({path: '/doctor'})
      } else if (to.path === '/' && UserStore.store.isClinic()) {
        next({path: '/clinic/general'})
      } else {
        next()
      }
    }).catch(() => {
      UserStore.store.redirectPath = to.path
      // If the user hasn't login
      if (to.path === '/auth/login') {
        next()
      } else {
        next({path: '/auth/login'})
      }
    })
  } else {
    if (to.path === '/' && UserStore.store.isClinicMulti()) {
      next({path: '/clinic_multi'})
    } else if (to.path === '/' && UserStore.store.isDoctor()) {
      next({path: '/doctor'})
    } else if (to.path === '/' && UserStore.store.isClinic()) {
      next({path: '/clinic/general'})
    } else {
      next()
    }
  }
})

export default router

export var UserStore = {
  install (_Vue, options) {
    _Vue.prototype.$guser = UserStore.store
  },
  setUser (user) {
    UserStore.store.user = user
  },
  getUser () {
    return UserStore.store.user
  },
  signedIn () {
    try {
      return !!UserStore.store.user.id
    } catch (e) {
      return false
    }
  },
  store: {
    user: {},
    async signout (redirectUrl) {
      try {
        await Vue.http.post(process.env.API_URL + '/api/v1/users/signout')
        UserStore.store.user = {}
      } catch (err) {
        console.info(err)
      }
    },
    isDoctor () {
      try {
        return !!UserStore.store.user.roles.find(r => r.role_name === 'Doctor').id
      } catch (e) {
        return false
      }
    },
    isClinic (router) {
      try {
        if (router && router.query.ref_clinic_id) {
          return this.isClinicMulti
        } else {
          return !!UserStore.store.user.roles.find(r => r.role_name === 'Clinic').id
        }
      } catch (e) {
        return false
      }
    },
    isClinicMulti () {
      try {
        return !!UserStore.store.user.roles.find(r => r.role_name === 'ClinicMulti').id
      } catch (e) {
        return false
      }
    },
    isActive () {
      if (UserStore.store.isDoctor() && UserStore.store.user.doctor.active) {
        return true
      } else if (UserStore.store.user.clinic && UserStore.store.user.clinic.active) {
        return true
      }
      return false
    },
    isPremiumAccount () {
      if (UserStore.store.isDoctor() && UserStore.store.user.doctor.account_status === 'premium') {
        return true
      } else if (UserStore.store.user.clinic && UserStore.store.user.clinic.account_status === 'premium') {
        return true
      }
      return false
    },
    hasSignedIn () {
      try {
        return !!UserStore.store.user.id
      } catch (e) {
        return false
      }
    },
    changeLang (lang) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js